package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable

@Composable
actual fun CallAudioEffect(active: Boolean) {
}
